import React from 'react';
import styled from 'styled-components';

// Importar a imagem do Visa
import bannerImage from '../../assets/visabanner.jpg'; // Caminho relativo atualizado

// Estilização do Banner
const BannerContainer = styled.div`
  width: 100%;
  height: 60vh;  /* Ajustado para um impacto visual consistente com o Banner Companies */
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  @media (max-width: 768px) {
    height: 50vh;  /* Ajuste para dispositivos móveis */
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    border-radius: 15px;
  }
`;

const MainTextOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 3rem;  /* Tamanho grande para visibilidade */
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  text-shadow: 3px 3px 6px rgba(0, 0, 0, 0.7);
  text-align: center;
  z-index: 3;

  @media (max-width: 768px) {
    font-size: 2.5rem;
  }

  @media (max-width: 480px) {
    font-size: 2rem;
  }
`;

const VisaBanner = () => {
  return (
    <BannerContainer>
      <MainTextOverlay>Seu guia para vistos em Portugal</MainTextOverlay>
      <Image src={bannerImage} alt="Visa Application Banner" />
    </BannerContainer>
  );
};

export default VisaBanner;
